import { render, staticRenderFns } from "./descuentoCupon.vue?vue&type=template&id=79b15648&"
import script from "./descuentoCupon.vue?vue&type=script&lang=js&"
export * from "./descuentoCupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports